import { render, staticRenderFns } from "./mealsList.vue?vue&type=template&id=15f6fce7&scoped=true"
import script from "./mealsList.vue?vue&type=script&lang=js"
export * from "./mealsList.vue?vue&type=script&lang=js"
import style0 from "./mealsList.vue?vue&type=style&index=0&id=15f6fce7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f6fce7",
  null
  
)

export default component.exports